import { Injectable } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { mergeMap } from 'rxjs/operators'
import { clearCommands } from '../../commands'
import { clearFilters } from '../../filters'
import { clearFocused } from '../../focused'
import { clearExternalTransactions } from '../../panels/external-transaction'
import { clearTransactions } from '../../panels/transactions'
import { inactivateSession, setActiveSession } from './session.reducer'

@Injectable()
export class SessionEffects {
  clearOnNewSession$ = createEffect(() =>
    this.actions$.pipe(
      ofType(setActiveSession, inactivateSession),
      mergeMap(() => [
        clearFocused(),
        clearFilters(),
        clearTransactions(),
        clearExternalTransactions(),
        clearCommands(),
      ]),
    ),
  )

  constructor(private readonly actions$: Actions) {}
}
